import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useLocation, useNavigate, useParams} from 'react-router-dom';

import {stepperData} from '../../contants';
import SelectStep from '../../elements/selectedStep';
import {RootState} from '../../../../../store/redux';
import DotsLoading from '../../../../../components/dotsLoading';
import Stepper from '../../../../../components/mazraeKit/stepper';
import SuccessRegisterStoreModal from '../../modal/successRegisterStoreModal';
import MainFooter from '../../../../../components/mazraeKit/footers/footerMain';
import CustomHeader from '../../../../../components/mazraeKit/headers/homeHeader';
import {usePutLabRedesignView} from '../../../../../services/hookService/putLabRedesignView/usePutLabRedesignView';
import useGetStoreSupplierProfile from '../../../../../services/hookService/getStoreSupplierProfile/useGetStoreSupplierProfile';
import useCreateObjEditLab from '../comments/createObjEditLab';
import {addRegisterStoreFormData} from '../../../../../store/redux/registerStore';
import useGetLabDetail from '../../../../../services/hookService/getLabDetail/useGetLabDetail';

const EditRegisterLab = () => {
  const dispatch = useDispatch();
  const {state: stateParams} = useLocation();
  const params = useParams();
  const state = useSelector((state: RootState) => state.registerStore);
  const navigate = useNavigate();
  const [touched, setTouched] = useState(false);
  const [currentStep, setCurrentStep] = useState<number>(4);
  const [isSuccessModal, setIsSuccessModal] = useState<boolean>(false);

  const handleAfterSuccessSupplierProfile = (data: IStoreSupplierProfile) => {
    if (!state?.national_card?.file && !state?.national_card?.national_card) {
      dispatch(
        addRegisterStoreFormData({
          ...state,
          name: data?.name,
          supplier_profile_guid: data?.profile_guid,
          national_card: {file: null, national_card: data.national_card},
          phone_number: data.phone,
        }),
      );
    }
  };

  const {mutate, isLoading: isLoadingMutattion} = usePutLabRedesignView({
    onSuccess: () => setIsSuccessModal(true),
  });

  const {data, isLoading} = useGetStoreSupplierProfile({
    handleAfterSuccessSupplierProfile,
  });

  const {labData, labDataIsLoading} = useGetLabDetail({
    lab_guid: params.lab_guid,
  });

  useCreateObjEditLab(labData);

  useEffect(() => {
    setCurrentStep(stateParams?.tab || 2);
  }, [stateParams?.tab]);

  return (
    <div className="flex h-full flex-col">
      <CustomHeader
        title="ثبت آزمایشگاه"
        isActiveRightIcon={true}
        preIcon="icon-nameArrow---Right"
        postComponent={() => (
          <i
            className={`icon-namechat text-[25px] text-gray-700`}
            onClick={() => {
              navigate('/my-chats');
            }}
          />
        )}
      />
      {isLoading || labDataIsLoading ? (
        <div className="flex h-full justify-center items-center">
          <DotsLoading />
        </div>
      ) : (
        <div className="flex flex-col h-full">
          <div className="w-full h-full flex flex-col overflow-y-auto py-3 px-3">
            <Stepper currentStep={currentStep} steps={stepperData} />
            <SelectStep
              setCurrentStep={setCurrentStep}
              setTouched={setTouched}
              touched={touched}
              currentStep={currentStep}
              setIsSuccessModal={setIsSuccessModal}
              storeGuid={stateParams?.guid}
              mutateFn={mutate}
              profileData={data}
              isLoadingMutattion={isLoadingMutattion}
              mode="edit"
              type="lab"
            />
          </div>
          <SuccessRegisterStoreModal {...{isSuccessModal, setIsSuccessModal}} />
        </div>
      )}
      <MainFooter />
    </div>
  );
};

export default EditRegisterLab;
